(() => {
  const initialize = (root = document) => {
    root.querySelectorAll('.new-products-tabs[data-section-id]').forEach((section) => {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      const buttons = [...section.querySelectorAll('[data-new-products-tab-button]')];
      const panels = [...section.querySelectorAll('[data-new-products-tab-panel]')];
      const viewAll = section.querySelector('[data-new-products-view-all]');
      const requests = new Map();
      const load = (button) => {
        const id = button.dataset.newProductsTabButton;
        const panel = panels.find((item) => item.dataset.newProductsTabPanel === id);
        if (!panel || panel.dataset.productsLoaded === 'true') return Promise.resolve();
        if (requests.has(id)) return requests.get(id);
        panel.setAttribute('aria-busy', 'true');
        const url = new URL(button.dataset.collectionUrl, location.origin);
        url.searchParams.set('section_id', section.dataset.sectionId);
        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(), 15000);
        const request = fetch(url, { signal: controller.signal, credentials: 'same-origin' })
          .then((response) => {
            if (!response.ok) throw new Error('Section unavailable');
            return response.text();
          })
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const content = [...doc.querySelectorAll('[data-new-products-tab-panel]')]
              .find((item) => item.dataset.newProductsTabPanel === id);
            if (!content || content.dataset.productsLoaded !== 'true') throw new Error('Invalid product section');
            if (!content.querySelector('[data-product-id]')) {
              content.querySelectorAll('carousel-slider, .products-grid-container').forEach((node) => node.remove());
            }
            panel.replaceChildren(...[...content.childNodes].map((node) => document.importNode(node, true)));
            panel.dataset.productsLoaded = 'true';
            panel.querySelectorAll('[data-cc-animate]').forEach((node) => {
              node.removeAttribute('data-cc-animate');
              node.removeAttribute('data-cc-animate-delay');
            });
          })
          .catch(() => {
            panel.querySelectorAll('carousel-slider, .products-grid-container').forEach((node) => { node.hidden = true; });
            const fallback = panel.querySelector('.new-products-fallback');
            if (fallback) fallback.hidden = false;
            requests.delete(id);
          })
          .finally(() => { clearTimeout(timer); panel.setAttribute('aria-busy', 'false'); });
        requests.set(id, request);
        return request;
      };
      const select = (button) => {
        buttons.forEach((item) => {
          const selected = item === button;
          item.classList.toggle('is-active', selected);
          item.setAttribute('aria-selected', String(selected));
          item.tabIndex = selected ? 0 : -1;
        });
        panels.forEach((panel) => panel.classList.toggle('is-active', panel.dataset.newProductsTabPanel === button.dataset.newProductsTabButton));
        if (viewAll) viewAll.href = button.dataset.collectionUrl;
        load(button).then(() => window.dispatchEvent(new Event('on:debounced-resize')));
      };
      buttons.forEach((button, index) => {
        button.addEventListener('click', () => select(button));
        button.addEventListener('pointerenter', () => load(button), { once: true });
        button.addEventListener('focus', () => load(button), { once: true });
        button.addEventListener('keydown', (event) => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % buttons.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + buttons.length) % buttons.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = buttons.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          buttons[next].focus();
          select(buttons[next]);
        });
      });
      const active = buttons.find((button) => button.classList.contains('is-active')) || buttons[0];
      if (active) {
        if ('IntersectionObserver' in window) {
          const observer = new IntersectionObserver((entries) => {
            if (entries.some((entry) => entry.isIntersecting)) { load(active); observer.disconnect(); }
          }, { rootMargin: '600px' });
          observer.observe(section);
        } else load(active);
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
